/* eslint-disable @typescript-eslint/no-explicit-any */
import axios from 'axios';
import CustomError from 'interface/CustomError';
import { makeHeader } from 'libs/mindUtils';

export const postFetcherHeaderWithParam = async <T>(url: string, token: string, params: T): Promise<any> => {
  const response = await axios.post(url, params, makeHeader(token));
  return response.data || [];
};

export const fetcherHeaderWithParam = async <T>(url: string, token: string, params?: T): Promise<any> => {
  const start = Date.now();
  const response = await axios.get(url, { params, ...makeHeader(token) });
  const end = Date.now(); // 요청 완료 시간 기록
  const duration = (end - start) / 1000;
  return { data: response.data, duration };
};

export const fetcherHeaderWithParamHandling = async <T>(url: string, token: string, params?: T): Promise<any> => {
  let response;
  try {
    response = await axios.get(url, { params, ...makeHeader(token) });
  } catch (error) {
    if (axios.isAxiosError(error)) {
      throw new CustomError('error', error.response?.data, error.response?.status);
    } else {
      throw new Error('A network error.');
    }
  }
  return { data: response.data };
};
